import React, {useEffect, useState} from "react";
import {motion, useAnimation} from "framer-motion";
import "./Select.css";

let Select = (props) => {
    let [current, setCurrentItem] = useState("Test");
    let [items, setItems] = useState([]);
    let [viewShown, showView] = useState(false);
    let [offsetY, setOffsetY] = useState(0);
    let [offsetX, setOffsetX] = useState(0);
    let animation = useAnimation();


    const showSelectionView = (e) => {
        showView(e);
        // console.log("show")
        // setOffsetX(document.getElementById('selectBox').getBoundingClientRect().left)
        //  setOffsetY(document.getElementById('selectBox').getBoundingClientRect().top+window.scrollY+32);
     }

    useEffect(()=>{
        setCurrentItem(props.selected);
        props.onChange(props.selected);

        let genItems = [];

        props.items.forEach((item)=>{
            genItems.push(
                <div onClick={()=>{
                    showSelectionView(false)
                    setCurrentItem(item)
                    props.onChange(item)
                }} className="Select--item">
                    {item}
                </div>
            );
        })
        setItems(genItems);
    }, [])

    return(
        <div className="Select">
            <div className="Select--title">
                {props.title}
            </div>
            <div id="selectBox" onClick={()=>{showSelectionView(true)}} className="Select--box">
                <div className="Select--box-inner">
                    {current}
                    <div className="Select--arrow-box">
                        <div className="Select--arrow"/>
                    </div>
                </div>
            </div>
            {viewShown ?
                <div className="Select--items-box" onWheel={(wheel)=>{
                }}>
                    <div className="Select--items">
                        <motion.div
                            initial={{
                                scale:0,
                                y:offsetY-24,
                                x:offsetX
                            }}
                            animate={{
                                scale:1,
                                y:offsetY,
                                x:offsetX
                            }}
                            className="Select--items-in">
                            {items}
                        </motion.div>
                    </div>
                    <div className="Select--view" onClick={()=>{showSelectionView(false)}}/>
                </div>
                :
                false
            }
        </div>
    );
}
export default Select;